/* eslint-disable no-unused-vars */
/*
 * getTopWindow retrieves the top-most Mailchimp window. In the case of QB-Bundles flow
 *    where we render the mailchimp signup within a QBO iframe we want to make sure
 *    developers aren't using window.top and referring to the QBO window
 */
export const getTopWindow = () => {
  // current window is at top
  if (window === window.parent) {
    return window;
  }

  // if top is different from parent, top is QBO and parent is MC
  if (window.parent !== window.top) {
    return window.parent;
  }

  // if top window is same as parent, it can be either QBO or MC. We need to check the location of window.top to investigate
  if (window.parent === window.top) {
    try {
      const href = window.top.location.href;
      // top-most window is MC since accessing href did not throw an error
      return window.parent;
    } catch (e) {
      // top-most window is QBO since accessing href threw an error
      return window;
    }
  }
};

/*
 * isInIframe compares the current window to the top window to see if the user is in an iframe
 *    For QB-Bundles flow, since window.top is the QBO iframe, we are comparing window to window.parent
 */
export const isInIframe = () => {
  if (window === window.parent) {
    return false;
  }
  if (window.parent !== window.top) {
    return true;
  }

  // if top window is same as parent, it can be either QBO or MC. We need to check the location of window.top to investigate
  if (window.parent === window.top) {
    try {
      const href = window.top.location.href;
      // top-most window is MC since accessing href did not throw an error
      return true;
    } catch (e) {
      // top-most window is QBO since accessing href threw an error
      return false;
    }
  }
};

/**
 * isIntuitDomain checks if the current window is on an Intuit domain. We will likely
 * iterate on this method to avoid domain sniffing, but it works for now.
 *
 * @returns {boolean} true if the current window is on an Intuit domain, false otherwise
 */
export const isIntuitDomain = () => {
  try {
    return window.top.location.hostname.endsWith('.intuit.com');
  } catch (e) {
    return false;
  }
};
